







import {Component, Vue} from "vue-property-decorator";
import StoriesViewer from '~/stories_widget/components/Stories/StoriesViewer/StoriesViewer';


@Component({
    name: "ScreenOrientationLock",
})
export default class ScreenOrientationLock extends Vue {
    mounted() {
        (<StoriesViewer>this.$parent).pauseAndBlockViewerUI();
    }
    destroyed() {
        (<StoriesViewer>this.$parent).resumeAndEnableViewerUI();
    }


}

